import { useHistory, useLocation } from 'react-router';
import useLocale from '@/hooks/useLocale';
import type { UseIsHomeRouteResult, UseIsHomeRouteRoutesBase } from './useIsHomeRoute.types';

/**
 * Exposes `history`, locale `routes`, and `isHome` (`pathname === routes.home`).
 *
 * Pass `TRoutes` extending `{ home: string }` when callers need additional typed route keys (e.g. `gatorProtect`).
 * Must run under a `Router` and `LocaleProvider`.
 */
export function useIsHomeRoute<
  T extends UseIsHomeRouteRoutesBase = UseIsHomeRouteRoutesBase,
>(): UseIsHomeRouteResult<T> {
  const history = useHistory();
  const { pathname } = useLocation();
  const { routes } = useLocale() as { routes: T };
  const isHome = pathname === routes.home;

  return {
    isHome,
    history,
    routes,
  };
}
